<nav #navbar class="navbar navbar-expand-lg navbar-absolute" [ngClass]="{ 'bg-white': open === true , 'navbar-transparent': open === false}">
  <div class="container-fluid">

    <div class="navbar-wrapper">
      <div class="navbar-minimize" style="margin-left: 19px;" [style.display]="isMobile ? 'none' : 'block'">
        <button id="minimizeSidebar" class="btn btn-icon btn-round" (click)="minimizeSidebar()">
          <i class="nc-icon nc-minimal-right text-center visible-on-sidebar-mini"></i>
          <i class="nc-icon nc-minimal-left text-center visible-on-sidebar-regular"></i>
        </button>
      </div>
      <div class="navbar-toggle" (click)="sidebarToggle()" style="margin-left: 19px; margin-top: 2px" [style.display]="isMobile ? 'block' : 'none'">
        <button type="button" class="navbar-toggler"  style="height:40px; border: none !important; outline: none !important; box-shadow: none !important;">
          <span id="toggle-1" class="navbar-toggler-bar icon-bar bar1"></span>
          <span id="toggle-2" class="navbar-toggler-bar icon-bar bar2"></span>
          <span id="toggle-3" class="navbar-toggler-bar icon-bar bar3"></span>
        </button>
      </div>
      <a class="navbar-brand" href="javascript:void(0)"><h2>{{title}}</h2></a>
    </div>
  </div>
</nav>
